import api from "../../api";
import { downloadTransactionExcelEndPoint } from "../../api/apisUrl";
import { FilterTransactionDetails } from "../../models";
import {
  DOWNLOAD_TRANSACTIONS_EXCEL_LOADING,
  DOWNLOAD_TRANSACTIONS_EXCEL_SUCCESS,
  DOWNLOAD_TRANSACTIONS_EXCEL_FAILED,
} from "../types";

export const downloadTransactionsExcel = (
  token: string,
  filterDetails: FilterTransactionDetails,
  pageNumber: number,
  merchantId?: string,
  outletId?: string,
  userId?: string,
  partnerIds?: string[],
) => {
  return async (dispatch: any) => {
    dispatch({ type: DOWNLOAD_TRANSACTIONS_EXCEL_LOADING });
    try {
      const response = await api.get(
        downloadTransactionExcelEndPoint(
          filterDetails,
          pageNumber,
          merchantId,
          userId,
          outletId,
          partnerIds,
        ),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        },
      );
      const blobUrl = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "transactions_report.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      dispatch({ type: DOWNLOAD_TRANSACTIONS_EXCEL_SUCCESS });
    } catch (err) {
      dispatch({
        type: DOWNLOAD_TRANSACTIONS_EXCEL_FAILED,
        error: err,
      });
    }
  };
};
